import { render } from "./IconTopUp.vue?vue&type=template&id=239ed8b6"
import script from "./IconTopUp.vue?vue&type=script&lang=js"
export * from "./IconTopUp.vue?vue&type=script&lang=js"

import "./IconTopUp.vue?vue&type=style&index=0&id=239ed8b6&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__